import type { FormikValues } from 'formik';

import { PASSWORD_MIN_LENGTH } from 'app/design-system/components/Input/constants';
import type { tFunction } from 'app/lang';

import dictionary from './PasswordForm.dictionary.json';

type ValidateErrors = {
  phoneNumber?: string;
  email?: string;
  newPass?: string;
  confirmPass?: string;
};


export const getValidate = (t: tFunction) => {
  return (values: FormikValues): ValidateErrors => {
    const errors: ValidateErrors = {};
    const { newPass, confirmPass, login } = values;

    Object.keys(values).forEach(() => {
      if (newPass.length < PASSWORD_MIN_LENGTH) {
        errors.newPass = t(dictionary.passwordRequired, { count: PASSWORD_MIN_LENGTH });
      }

      if (newPass && login && newPass === login) {
        errors.newPass = t(dictionary.passwordAndPhoneNotMatch);
      }

      if (newPass !== confirmPass) {
        errors.confirmPass = t(dictionary.passwordsNotMatch);
      }
    });

    return errors;
  };
};
